import React, { useEffect, useState } from 'react';
import './ContextMenu.css';

function ContextMenu({ isAboutPage, onAboutClick, position }) {
  const [visible, setVisible] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
      setPos({ x: e.clientX, y: e.clientY });
      setVisible(true);
    };

    const handleClick = () => {
      setVisible(false);
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('click', handleClick);
    document.addEventListener('scroll', handleClick);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('click', handleClick);
      document.removeEventListener('scroll', handleClick);
    };
  }, []);

  const handleMenuClick = (e) => {
    e.stopPropagation();
    onAboutClick();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="context-menu" style={{ top: `${pos.y}px`, left: `${pos.x}px` }}>
      <button className="context-menu-item" onClick={handleMenuClick}>
        {isAboutPage ? 'Home' : 'About'}
      </button>
    </div>
  );
}

export default ContextMenu;
